module.exports = __webpack_public_path__ + "static/media/viewAuditTrailGuide.c39f2a54.png";